import Icon from "@material-ui/icons/LocalAtm";
import Create from "./RateChartCreate";
import Edit from "./RateChartEdit";
import Show from "./RateChartShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "rateCharts",
  edit: Edit,
  create: Create,
  show: Show,
  icon: Icon,
};
